<template>
  <v-container fluid>
    <v-row class="mb-0">
      <v-col>
        <h1>Анкета</h1>
      </v-col>
    </v-row>
    <patient-header />
    <v-card id="interview" class="mb-5">
      <v-data-table
        disable-pagination
        hide-default-footer
        :headers="headers"
        :items="items"
        :loading="loading"
        :options.sync="options"
      >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import PatientHeader from "@/components/PatientHeader";
export default {
  components: {
    PatientHeader,
  },

  data: () => ({
    loading: false,
    items: [],
    options: {},
    headers: [
      { text: "Вопрс", value: "question" },
      { text: "Ответ", value: "value" },
    ],
  }),

  computed: {
    customerId() {
      return this.$store.state.customer.id;
    },
  },

  async created() {
    await this.load();
  },

  methods: {
    async load() {
      this.loading = true;

      try {
        const r = await this.$http.get(`v1/customers/${this.customerId}/interview-results`).then(r => r.data);
        if (r.success) {
          this.items = r.data;
        }
      } catch (e) {
        // TODO: Обработать ошибку
        console.error(e);
      }
      this.loading = false;
    },
  },
};
</script>

<style></style>
